import React from 'react';
import './StaticPage.css';

export default function PrivacyPolicy() {
  return (
    <div className="static-page container">
      <h1 className="display-title">Privacy Policy</h1>
      <div className="static-content">
        <p>At Asquaretravelgoa, your privacy is of paramount importance to us.</p>
        <h3>Data Collection</h3>
        <p>We collect personal information such as your name, email address, phone number, and travel preferences when you submit an enquiry or book a trip.</p>
        <h3>How We Use Your Data</h3>
        <p>Your information is used solely to process your bookings, communicate with you regarding your trip, and improve our services.</p>
        <h3>Data Protection</h3>
        <p>We implement industry-standard security measures to protect your personal information from unauthorized access.</p>
      </div>
    </div>
  );
}
